
import { contentFileUpload } from '@/api/course-builderapi'
import { getUploadedFilesId } from '@/api/assignment-question'
import {
  fetchUserClint,
  blogShare,
  blogCreate,
  blogEdit,
  blogDelete,
  blogList,
  fetchBlog,
  createComment,
  editComment,
  showComment,
  deleteComment,
  emoticonsUpdate,
  emoticonsDelete,
  commentsEmoticonsUpdate,
  commentsEmoticonsDelete
} from '@/api/blog-post.js'
export const blog = {
  data () {
    return {
      file_repository_id:'',
      initializeTinyMce:{
        setup :(editor) => {
          editor.ui.registry.addIcon('filesIcon', '<svg class="primary_svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V6h5.17l2 2H20v10zm-6.92-3.96L12.39 17 15 15.47 17.61 17l-.69-2.96 2.3-1.99-3.03-.26L15 9l-1.19 2.79-3.03.26z"/></svg>')
          editor.ui.registry.addIcon('gDriveIcon', '<svg class="font_18" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "></polyline><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "></polyline><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "></polyline></g></svg>')
          editor.ui.registry.addButton('customInsertButton', {
            icon: 'filesIcon',
            tooltip: 'Insert Image from repo',
            onAction:() => { this.importModelRepo(editor) }
          })
          editor.ui.registry.addButton('gDrive', {
            icon: 'gDriveIcon',
            tooltip: 'Insert from GDrive',
            onAction:() => { this.gDrive(editor) }
          })
        },
        
        height: 400,
        menubar: true,
        branding: false,
        images_upload_url: this.image_url,
        automatic_uploads: true,
        images_upload_credentials: true,
        images_upload_handler: this.example_image_upload_handler,

        plugins: [
          'autolink lists link image charmap print preview anchor',
          'imagetools',
          'searchreplace visualblocks code fullscreen',
          'insertdatetime media table paste code help wordcount',
          'code lists fullscreen',
          'emoticons'
        ],
        menu: 'table',
        toolbar:
              'customInsertButton gDrive insertfile image link |undo redo | formatselect | bold italic backcolor | \
        table alignleft aligncenter alignright alignjustify | \
        bullist numlist outdent indent | removeformat | help'
      },
      showBlogData: null,
      query_page: {
        page: 1,
        search: ''
      },
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
      currentPageUser: '',
      currentPageClient: '',
      showButtonClient: true,
      showButtonUser: true,
      selectedUsersShow: [],
      selectedClientsShow: [],
      currentPage: '',
      showButton: true,
      searchData: '',
      shareBlogId: '',
      blogDeletePopUpId: '',
      deletepopupflag: false,
      blogData: {
        blog: '',
        is_shared: false,
        title: ''
      },
      fetchBlogData: [],
      customerName: '',
      userPicture: '',
      customerType: localStorage.getItem('role_permission'),
      updateId: '',
      shared: true,
      image_url: '',
      shareActive: false,
      shareActive1: false,
      modalEditActive: false,
      modalActive: false,
      commentsData: {
        portal_type: 'A',
        parent_id: '0',
        comments: ''
      },
      commentsData2: {
        comments: []
      },
      replyData: {
        portal_type: 'A',
        parent_id: '',
        comments: ''
      },
      replyData2: {
        comments: []
      },
      emoticonsList: [],
      commentsShow: [],
      emoticons: {
        portal_type: 'A',
        emoticons_id: ''
      },
      userList: [],
      userList2: [],
      userListForAdd: [],
      clientListForAdd: [],
      clientList: [],
      editCommentBoxShow: false,
      editReplyBoxShow: false,
      editBlogId: '',
      editCommentId: '',
      previousId: 1,
      trialData: '',
      selectedUsers: [],
      selectedClients: [],
      selectedUsers2: [],
      selectedClients2: [],
      user: [],
      multipleSelections: ['Mr Potato (Manager)'],
      data: null,
      multiple: 'true',
      tinyMceApi:'',
      editorComponent:null,
      isBrowseContent:false
    }
  },
  methods: {
    getImportFile ({ file_id, fileInfo }) {
      fileInfo.forEach((eachFile) => {
        this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="auto" height="auto"/>`)
      })
      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)
    },
    gDrive (editor) {
      this.editorComponent = editor
      this.driveIconClicked('Communications')
    },
    importModelRepo (editor) {
      this.editorComponent = editor
      this.isBrowseContent = true
    },
    async getUploadFiles (file_id_payload, type = 'system') {
      console.log('hi')
      const res = await getUploadedFilesId(file_id_payload)

      // console.log()
      const filesDriveInfo = res.data.data.files
      if (type === 'drive') {
        filesDriveInfo.forEach((eachFile) => {
          if (eachFile.file_type.split('/')[0] === 'image') {
            this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="200" height="200"/>`)
          } else if (eachFile.file_type.split('/')[0] === 'video') {
            this.editorComponent.insertContent(`<video width="200" height="300"<source src="${  eachFile.file_path  }"</video>`)
            

          } else if (eachFile.file_type.split('/')[0] === 'audio') {
            this.editorComponent.insertContent(`<img src="${eachFile.file_path}" width="200" height="200"/>`)
          }
        })
        console.log(filesDriveInfo)
      }

    },
    closeSelectedUser (index) {
      this.selectedUsers.splice(index, 1)
    },
    closeSelectedClient (index) {
      this.selectedClients.splice(index, 1)
    },
    closeSelectedUser2 (index) {
      this.selectedUsers2.splice(index, 1)
    },
    closeSelectedClient2 (index) {
      this.selectedClients2.splice(index, 1)
    },
    fetchUser () {
      fetchUserClint(
        localStorage.getItem('customer_id'),
        'User',
        this.query_page_user
      )
        .then((res) => {  
          this.userList = res.data.data.users_list
          this.userListForAdd = res.data.data.users_list
          this.showButtonUser = res.data.data.meta.has_next
        })
        .catch((e) => {
                
        })
    },
    fetchClient () {
      fetchUserClint(
        localStorage.getItem('customer_id'),
        'Client',
        this.query_page_client
      )
        .then((res) => {  
          this.clientList = res.data.data.users_list
          this.clientListForAdd = res.data.data.users_list
          this.showButtonClient = res.data.data.meta.has_next
        })
        .catch((e) => {
                
        })
    },
    showMoreUser () {
      this.query_page_user.page = this.query_page_user.page + 1
      this.currentPageUser = this.query_page_user.page
      this.fetchUser()
      
    },
    showMoreClient () {
      this.query_page_client.page = this.query_page_client.page + 1
      this.currentPageClient = this.query_page_client.page
      this.fetchClient()  
    },
    showBackUser () {
      this.query_page_user.page = this.currentPageUser - 1
      this.currentPageUser = this.query_page_user.page
      this.fetchUser()
    },
    showBackClient () {
      this.query_page_client.page = this.currentPageClient - 1
      this.currentPageClient = this.query_page_client.page
      this.fetchClient()
    },
    images_upload_handler (blobInfo, success, failure) {
      const xhr = new XMLHttpRequest()
      xhr.withCredentials = true
      xhr.open('POST', this.image_url)

      xhr.upload.onprogress = function (e) {
        progress((e.loaded / e.total) * 100)
      }

      xhr.onload = function () {
        // let json

        if (xhr.status === 403) {
          failure(`HTTP Error: ${xhr.status}`, { remove: true })
          return
        }

        if (xhr.status < 200 || xhr.status >= 300) {
          failure(`HTTP Error: ${xhr.status}`)
          return
        }

        const json = JSON.parse(xhr.responseText)

        if (!json || typeof json.location !== 'string') {
          failure(`Invalid JSON: ${xhr.responseText}`)
          return
        }

        success(json.location)
      }

      xhr.onerror = function () {
        failure(
          `Image upload failed due to a XHR Transport error. Code: ${xhr.status}`
        )
      }

      xhr.setRequestHeader(
        'Authorization',
        `Bearer ${JSON.parse(localStorage.getItem('access_token'))}`
      )

      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob(), blobInfo.filename())
      xhr.send(formData)
    },
    example_image_upload_handler (blobInfo, success, failure, progress) {
      const formData = new FormData()
      formData.append('files[0]', blobInfo.blob())

      const data = this.fileupload(formData)

      data
        .then((res) => {
          
          const locationObject = {
            src: {
              value: {
                location: res
              }
            }
          }

          const stringify = JSON.stringify(res)
          const parse = JSON.parse(stringify)
          
          success(parse)
        })
        .catch((error) => {
          
        })
    },

    async fileupload (payload) {
      try {
        const customer_id = localStorage.getItem('customer_id')

        

        const responseImage = await contentFileUpload(customer_id, payload)
        const location =
          responseImage.data.data.cdn +
          responseImage.data.data.files[0].file_path
        this.$vs.notify({
          title: 'Success',
          text: 'Image Uploaded Successfully',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success',
          time: 3000
        })
        return location
      } catch (error) {
        
      }
    },

    blogListFetch () {
      this.query_page.search = this.searchData
      blogList(localStorage.getItem('customer_id'), this.query_page)
        .then((res) => {
          
          this.showButton = res.data.data.meta.has_next
          this.fetchBlogData = res.data.data.blogs
        })
        .catch((e) => {
          
        })
    },
    openWithDetails (id) {
      this.$router
        .push({
          name: 'Blogs-Post-Details',
          params: { Id: id}
        })
        .catch(() => {})
    },

    submitWithShare (dataShared) {
      console.log(dataShared)
      this.shareActive1 = true
      /* if (dataShared === true) {
        this.blogData.is_shared = true
      } */
    },

    submit (isShared) {
      if (isShared) {
        const arr = []
        for (let i = 0; i < this.selectedUsers2.length; i++) {
          arr.push({
            user_type: this.selectedUsers2[i].user_type,
            users_id: this.selectedUsers2[i].users_id
          })
        }
        for (let i = 0; i < this.selectedClients2.length; i++) {
          arr.push({
            user_type: this.selectedClients2[i].user_type,
            users_id: this.selectedClients2[i].client_users_id
          })
        }

        this.blogData.userArray = arr
        this.blogData.is_shared = true
      } else {
        delete this.blogData.userArray
        this.blogData.is_shared = false
      }

      blogCreate(localStorage.getItem('customer_id'), this.blogData)
        .then((res) => {
          const afterCreate = res.data.data.blog
          this.fetchBlogData.unshift(afterCreate)
          this.$vs.notify({
            title: 'Success',
            text: 'Blog Posted',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.blogData.blog = ''
          this.blogData.title = ''
          this.blogData.is_shared = false
          this.selectedClients2 = []
          this.selectedUsers2 = []
          this.shareActive1 = false
        })
        .catch((e) => {
          if (e.status === 422) {
            this.$vs.notify({
              title: 'Warning',
              text: 'Please select user to share',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.shareActive1 = false
            this.selectedClients2 = []
            this.selectedUsers2 = []

            this.$vs.notify({
              title: 'Warning',
              text: 'Something Went Wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          }
        })
    },
    async editPopup (id) {
      try {  
        const { data } = await fetchBlog(localStorage.getItem('customer_id'), id)
        this.updateId = id
        this.blogData.blog = data.data.blog.blog
        this.blogData.title = data.data.blog.title
        this.modalEditActive = true
      } catch (e) {
        //
      }
    },
    blogUpdate () {
      blogEdit(
        localStorage.getItem('customer_id'),
        this.updateId,
        this.blogData
      )
        .then((res) => {
          const afterUpdate = res.data.data.blog
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === afterUpdate.id))
          this.fetchBlogData[objIndex].title = afterUpdate.title
          this.fetchBlogData[objIndex].blog = afterUpdate.blog
          this.$vs.notify({
            title: 'Success',
            text: 'Blog Updated',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.blogData.blog = ''
          this.blogData.title = ''
          this.blogData.is_shared = false
          this.modalEditActive = false
        })
        .catch((e) => {
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    blogDeletePopUp (blogId) {
      this.blogDeletePopUpId = blogId
      this.deletepopupflag = true
    },

    deleteBlog () {
      blogDelete(localStorage.getItem('customer_id'), this.blogDeletePopUpId)
        .then((res) => {
          
          const ids = [this.blogDeletePopUpId]
          for (const id of ids) {
            for (let i = 0; i < this.fetchBlogData.length; i++) {
              if (id === this.fetchBlogData[i].id) {
                this.fetchBlogData.splice(i, 1)
              }
            }
          }
          this.$vs.notify({
            title: 'Success',
            text: 'Blog deleted',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.deletepopupflag = false
        })
        .catch((e) => {
          
          this.deletepopupflag = false
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    sendComment (id, index1) {
      this.commentsData.comments = this.commentsData2.comments[index1]
      createComment(localStorage.getItem('customer_id'), id, this.commentsData)
        .then((res) => {
          const afterUpdate = res.data.data.comment
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === id))
          this.fetchBlogData[objIndex].comments.push(afterUpdate)
          this.$vs.notify({
            title: 'Success',
            text: 'You have commented to this blog',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.commentsData2.comments = []
          this.commentsData.comments = ''
          this.commentsData.parent_id = 0
        })
        .catch((e) => {
          
          this.commentsData2.comments = []
          this.commentsData.comments = ''
          this.commentsData.parent_id = 0
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },
    sendReply (id, commentId, index2) {
      this.replyData.parent_id = commentId
      this.replyData.comments = this.replyData2.comments[index2]
      createComment(localStorage.getItem('customer_id'), id, this.replyData)
        .then((res) => {
          const afterUpdate = res.data.data.comment
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === id))
          const commentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === commentId))
          this.fetchBlogData[objIndex].comments[commentIndex].children.push(afterUpdate)
          this.$vs.notify({
            title: 'Success',
            text: 'You have commented to this blog',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.replyData2.comments = []
          this.replyData.comments = ''
          this.replyData.parent_id = ''
        })
        .catch((e) => {
          
          this.replyData2.comments = []
          this.replyData.comments = ''
          this.replyData.parent_id = ''
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    toggleComment (folder) {
      if (this.$refs[folder.id][0].style.display === 'none') {
        this.$refs[folder.id][0].style.display = 'inline'
      } else {
        this.$refs[folder.id][0].style.display = 'none'
      }
    },

    showCommentById (blogId, comment) {
      this.editCommentId = comment.id
      this.showAllReply(blogId, this.editCommentId)
      if (this.$refs[comment.id][0].style.display === 'none') {
        this.$refs[comment.id][0].style.display = 'inline'
      } else {
        this.$refs[comment.id][0].style.display = 'none'
      }
    },
    showAllReply (id, editCommentsId) {
      showComment(localStorage.getItem('customer_id'), id, editCommentsId)
        .then((res) => {
          
          this.commentsShow = res.data.data.comments
        })
        .catch((e) => {
          
        })
    },

    commentEditView (blogId, commentId) {
      this.editCommentBoxShow = true
      this.editBlogId = blogId
      this.editCommentId = commentId

      showComment(localStorage.getItem('customer_id'), blogId, commentId)
        .then((res) => {
          
          this.commentsData.comments = res.data.data.comments.comments
        })
        .catch((e) => {
          
        })
    },

    editComment () {
      editComment(
        localStorage.getItem('customer_id'),
        this.editBlogId,
        this.editCommentId,
        this.commentsData
      )
        .then((res) => {
          const afterUpdate = res.data.data.comment
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === this.editBlogId))
          const commentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === this.editCommentId))
          this.fetchBlogData[objIndex].comments[commentIndex].comments = afterUpdate.comments
          this.$vs.notify({
            title: 'Success',
            text: 'Comment Updated',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.commentsData.comments = ''
          this.commentsData.parent_id = 0
          this.editCommentBoxShow = false
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    replyEditView (blogId, commentId, index2) {
      this.editReplyBoxShow = true
      this.editBlogId = blogId
      this.editCommentId = commentId

      showComment(localStorage.getItem('customer_id'), blogId, commentId)
        .then((res) => {
          
          this.trialData = res.data.data.comments
          this.replyData2.comments = [res.data.data.comments.comments]
          
          this.replyData.parent_id = res.data.data.comments.parent_id
        })
        .catch((e) => {
          
        })
    },

    editReply (index2) {
      this.replyData.comments = this.replyData2.comments[0]
      editComment(
        localStorage.getItem('customer_id'),
        this.editBlogId,
        this.editCommentId,
        this.replyData
      )
        .then((res) => {
          const afterUpdate = res.data.data.comment
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === this.editBlogId))
          const commentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === afterUpdate.parent_id))
          const replyIndex = this.fetchBlogData[objIndex].comments[commentIndex].children.findIndex((obj => obj.id === this.editCommentId))
          this.fetchBlogData[objIndex].comments[commentIndex].children[replyIndex].comments = afterUpdate.comments
          this.$vs.notify({
            title: 'Success',
            text: 'Comment Updated',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.replyData2.comments = []
          this.replyData.comments = ''
          this.replyData.parent_id = ''
          this.editReplyBoxShow = false
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    deleteComment (blogId, commentId) {
      deleteComment(
        localStorage.getItem('customer_id'),
        blogId,
        commentId,
        this.emoticons.portal_type
      )
        .then((res) => {
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const ids = [commentId]
          for (const id of ids) {
            for (let i = 0; i < this.fetchBlogData[objIndex].comments.length; i++) {
              if (id === this.fetchBlogData[objIndex].comments[i].id) {
                this.fetchBlogData[objIndex].comments.splice(i, 1)
              }
            }
          }
          this.$vs.notify({
            title: 'Success',
            text: 'Comment deleted',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    deleteReply (blogId, commentId, parentId) {
      deleteComment(
        localStorage.getItem('customer_id'),
        blogId,
        commentId,
        this.emoticons.portal_type
      )
        .then((res) => {
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const commentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === parentId))
          const ids = [commentId]
          for (const id of ids) {
            for (let i = 0; i < this.fetchBlogData[objIndex].comments[commentIndex].children.length; i++) {
              if (id === this.fetchBlogData[objIndex].comments[commentIndex].children[i].id) {
                this.fetchBlogData[objIndex].comments[commentIndex].children.splice(i, 1)
              }
            }
          }
          this.$vs.notify({
            title: 'Success',
            text: 'Comment deleted',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((e) => {
          
          this.$vs.notify({
            title: 'Warning',
            text: 'Something Went Wrong',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'warning'
          })
        })
    },

    emojiSelected (blogId, id, type = null) {
      this.emoticons.emoticons_id = id
      emoticonsUpdate(
        localStorage.getItem('customer_id'),
        blogId,
        this.emoticons
      )
        .then((res) => {
          const afterReaction = res.data.data.emoticons
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const filterUserId = this.fetchBlogData[objIndex].emoticons.filter(function (currentElement) {
            return currentElement.blog_users_id === afterReaction.blog_users_id
          })
          if (filterUserId.length !== 0) {
            this.fetchBlogData[objIndex].emoticons.splice(this.fetchBlogData[objIndex].emoticons.findIndex(item => item.blog_users_id === afterReaction.blog_users_id), 1)

            this.fetchBlogData[objIndex].emoticons.push(afterReaction)
          } else {
            this.fetchBlogData[objIndex].emoticons.push(afterReaction)
          }
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
        })
        .catch((e) => {
          
        })
    },
    emojiDelete (blogId, type = null) {
      emoticonsDelete(
        localStorage.getItem('customer_id'),
        blogId,
        this.emoticons.portal_type
      )
        .then((res) => {
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const objEmoIndex = this.fetchBlogData[objIndex].emoticons.findIndex((obj => obj.blog_users_id === this.user.id))
          this.fetchBlogData[objIndex].emoticons.splice(objEmoIndex, 1)
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
          
        })
        .catch((e) => {
          
        })
    },

    commentsEmojiSelected (blogId, id, commentId, type = null) {
      this.emoticons.emoticons_id = id
      commentsEmoticonsUpdate(
        localStorage.getItem('customer_id'),
        blogId,
        commentId,
        this.emoticons
      )
        .then((res) => {
          const afterReaction = res.data.data.emoticons
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const objCommentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === commentId))
          const filterUserId = this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.filter(function (currentElement) {
            return currentElement.comment_users_id === afterReaction.comment_users_id
          })
          if (filterUserId.length !== 0) {
            this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.splice(this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.findIndex(item => item.comment_users_id === afterReaction.comment_users_id), 1)

            this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.push(afterReaction)
          } else {
            this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.push(afterReaction)
          }
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
        })
        .catch((e) => {
          
        })
    },
    replyEmojiSelected (blogId, id, replyId, commentId, type = null) {
      this.emoticons.emoticons_id = id
      commentsEmoticonsUpdate(
        localStorage.getItem('customer_id'),
        blogId,
        replyId,
        this.emoticons
      )
        .then((res) => {
          const afterReaction = res.data.data.emoticons
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const objCommentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === commentId))
          const replyIndex = this.fetchBlogData[objIndex].comments[objCommentIndex].children.findIndex((obj => obj.id === replyId))
          const filterUserId = this.fetchBlogData[objIndex].comments[objCommentIndex].children[replyIndex].emoticons.filter(function (currentElement) {
            return currentElement.comment_users_id === afterReaction.comment_users_id
          })
          if (filterUserId.length !== 0) {
            this.fetchBlogData[objIndex].comments[objCommentIndex].children[replyIndex].emoticons.splice(this.fetchBlogData[objIndex].comments[objCommentIndex].children[replyIndex].emoticons.findIndex(item => item.comment_users_id === afterReaction.comment_users_id), 1)

            this.fetchBlogData[objIndex].comments[objCommentIndex].children[replyIndex].emoticons.push(afterReaction)
          } else {
            this.fetchBlogData[objIndex].comments[objCommentIndex].children[replyIndex].emoticons.push(afterReaction)
          }
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
        })
        .catch((e) => {
          
        })
    },

    commentsEmojiDelete (blogId, commentId, type = null) {
      commentsEmoticonsDelete(
        localStorage.getItem('customer_id'),
        blogId,
        commentId,
        this.emoticons.portal_type
      )
        .then((res) => {
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const objCommentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === commentId))
          const objEmoIndex = this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.findIndex((obj => obj.blog_users_id === this.user.id))
          this.fetchBlogData[objIndex].comments[objCommentIndex].emoticons.splice(objEmoIndex, 1)
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
        })
        .catch((e) => {
          
        })
    },
    replyEmojiDelete (blogId, commentId, replyId, type = null) {
      commentsEmoticonsDelete(
        localStorage.getItem('customer_id'),
        blogId,
        replyId,
        this.emoticons.portal_type
      )
        .then((res) => {
          const objIndex = this.fetchBlogData.findIndex((obj => obj.id === blogId))
          const objCommentIndex = this.fetchBlogData[objIndex].comments.findIndex((obj => obj.id === commentId))
          const objChildrenIndex = this.fetchBlogData[objIndex].comments[objCommentIndex].children.findIndex((obj => obj.id === replyId))
          const objEmoIndex = this.fetchBlogData[objIndex].comments[objCommentIndex].children[objChildrenIndex].emoticons.findIndex((obj => obj.blog_users_id === this.user.id))
          this.fetchBlogData[objIndex].comments[objCommentIndex].children[objChildrenIndex].emoticons.splice(objEmoIndex, 1)
          if (type !== null) {
            this.fetchBlogData = [this.fetchBlogData[objIndex]]
          }
        })
        .catch((e) => {
          
        })
    },

    openShareModal (id) {
      this.shareBlogId = id
      this.userList = this.userListForAdd
      this.clientList = this.clientListForAdd

      fetchBlog(localStorage.getItem('customer_id'), id)
        .then((res) => {
          const res2 = this.userList
          const res1 = res.data.data.blog.shared_user
          const result = res1.filter(function (o1) {
            return res2.some(function (o2) {
              return o1.id === o2.users_id // return the ones with equal id
            })
          })

          this.selectedUsersShow = res.data.data.blog.shared_user

          const res3 = this.clientList
          const res4 = res.data.data.blog.shared_client_user
          const result2 = res4.filter(function (o3) {
            return res3.some(function (o4) {
              return o3.id === o4.client_users_id // return the ones with equal id
            })
          })

          this.selectedClientsShow = res.data.data.blog.shared_client_user

          if (result.length > 0) {
            for (let i = 0; i < result.length; i++) {
              const idToRemove = result[i].id
              this.userList = this.userList.filter(
                (item) => item.users_id !== idToRemove
              )
            }
          }

          if (result2.length > 0) {
            for (let i = 0; i < result2.length; i++) {
              const idToRemove = result2[i].id
              this.clientList = this.clientList.filter(
                (item) => item.client_users_id !== idToRemove
              )
            }
          }
        })
        .catch((e) => {
          
        })
      this.shareActive = true
    },

    shareToUser () {
      const arr = []
      for (let i = 0; i < this.selectedUsers.length; i++) {
        if ('user_type' in this.selectedUsers[i]) {
          // added for error resolve 13/01/2021
          arr.push({
            user_type: this.selectedUsers[i].user_type,
            users_id: this.selectedUsers[i].users_id
          })
        }
      }

      for (let i = 0; i < this.selectedClients.length; i++) {
        if ('user_type' in this.selectedClients[i]) {
          arr.push({
            user_type: this.selectedClients[i].user_type,
            users_id: this.selectedClients[i].client_users_id
          })
        }
      }

      
      const payload = {
        userArray: arr
      }

      blogShare(localStorage.getItem('customer_id'), this.shareBlogId, payload)
        .then((res) => {
          
          this.$vs.notify({
            title: 'Success',
            text: 'Blog Shared',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
          this.selectedClients = []
          this.selectedUsers = []
          this.shareActive = false
        })
        .catch((e) => {
          if (e.status === 422) {
            this.$vs.notify({
              title: 'Warning',
              text: 'Please select user to share',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            this.shareActive = false
            this.$vs.notify({
              title: 'Warning',
              text: 'Something went wrong',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          }
        })
    },
    closeEditModal () {
      this.blogData.blog = ''
      this.blogData.title = ''
      this.modalEditActive = false
    },

    searchBlog () {
      this.query_page.search = this.searchData
      this.blogListFetch()
    },

    showMore () {
      this.query_page.search = this.searchData
      this.query_page.page = this.query_page.page + 1
      this.currentPage = this.query_page.page
      this.blogListFetch()
    },
    showBack () {
      this.query_page.search = this.searchData
      this.query_page.page = this.currentPage - 1
      this.currentPage = this.query_page.page
      this.blogListFetch() 
    }

  }
    
}
